module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "value": _vm.value,
      "label": "Artist",
      "name": "artist",
      "id": "artist",
      "persistent-hint": "",
      "hint": "The primary artist (author)",
      "required": "",
      "error-messages": _vm.errors.collect('artist')
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b99cbf4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inputs/InputTrackArtist.vue
// module id = 363
// module chunks = 0